import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AbsentGlyph, ClockGlyph, HourglassGlyph } from "../glyphs.js";
import { Button } from "../core/Button.js";
export function ExpiryMarker({ level, children, expanded = false, onToggle, plain = false, style, ...rest }) {
    if (level === "none")
        return null;
    const base = {
        display: "inline-flex",
        alignItems: "center",
        gap: "var(--space-075)",
        whiteSpace: "nowrap",
        fontSize: "var(--type-small-size)",
        lineHeight: "var(--type-small-line)",
    };
    if (level === "urgent" && plain) {
        return (_jsxs("span", { "data-expiry-marker": "urgent", ...rest, style: { ...base, color: "var(--ink-1)", fontWeight: "var(--type-small-weight-strong)", ...style }, children: [_jsx(ClockGlyph, {}), children] }));
    }
    if (level === "urgent") {
        return (_jsxs("button", { type: "button", "data-expiry-marker": "urgent", "aria-expanded": expanded, onClick: onToggle, ...rest, style: {
                ...base,
                border: "none",
                // The hover fill bleeds 6px past the glyph and the words on each side (E's
                // `ve-exp-btn`), drawn by two offset copies of the fill rather than a negative margin,
                // so the button's own box, and so the clock, starts on the column's edge.
                margin: "calc(var(--space-025) * -1) 0",
                padding: "var(--space-025) 0",
                borderRadius: "var(--radius-focus)",
                background: "var(--expiry-bg, transparent)",
                boxShadow: "calc(var(--space-075) * -1) 0 0 var(--expiry-bg, transparent), var(--space-075) 0 0 var(--expiry-bg, transparent)",
                color: "var(--ink-1)",
                fontFamily: "var(--font-sans)",
                fontWeight: "var(--type-small-weight-strong)",
                cursor: "pointer",
                transition: "background-color var(--dur-fast) var(--ease-out)",
                ...style,
            }, children: [_jsx(ClockGlyph, {}), children] }));
    }
    return (_jsxs("span", { "data-expiry-marker": level, ...rest, style: { ...base, color: "var(--ink-2)", fontWeight: "var(--type-small-weight)", ...style }, children: [level === "soon" ? _jsx(HourglassGlyph, {}) : _jsx(AbsentGlyph, {}), children] }));
}
export function ExpiryDetail({ children, action, style, ...rest }) {
    return (_jsxs("div", { "data-expiry-detail": "", ...rest, style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "var(--space-25)",
            margin: "var(--space-075) 0 var(--space-05)",
            padding: "14px var(--space-2)",
            borderRadius: "var(--radius-control)",
            background: "var(--tone)",
            color: "var(--ink-1)",
            fontSize: "var(--type-body-size)",
            lineHeight: "var(--type-body-line)",
            fontWeight: "var(--type-body-weight)",
            whiteSpace: "normal",
            cursor: "default",
            ...style,
        }, children: [_jsx("span", { style: { minWidth: 0 }, children: children }), action && _jsx(Button, { size: "sm", variant: "primary", ...action })] }));
}
